import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../loader/loader.component';
import { CursorComponent } from '../cursor/cursor.component';
import { ScrollTopComponent } from '../scroll-top/scroll-top.component';
import { HeaderComponent } from '../header/header.component';
import { HeaderResponsiveComponent } from '../header-responsive/header-responsive.component';

import { FooterComponent } from '../footer/footer.component';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SlideBannersComponent } from '../..//components/slidesSwiper/slide-banners/slide-banners.component';
import { HeaderPagesComponent } from '../../components/header-pages/header-pages.component';
import { InputsModule } from '../../components/inputs/inputs.module';
import { LoginComponent } from '../../components/modals/login/login.component';
import { NavMenuHeaderComponent } from '../../components/nav-menu-header/nav-menu-header.component';

import { ProductSoldComponent } from '../../components/modals/product-sold/product-sold.component';
import { RegisterComponent } from '../../components/modals/register/register.component';
import { PaginatorComponent } from '../../components/paginator/paginator.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { RecoverPassComponent } from '../../components/modals/recover-pass/recover-pass.component';
import { RecoverPasswordComponent } from '../../components/modals/recover-password/recover-password.component';
import { GuideModalComponent } from 'src/app/components/guide-modal/guide-modal.component';
import { ReviewModalComponent } from 'src/app/components/review-modal/review-modal.component';
import { PostRegistrationWelcomeComponent } from 'src/app/components/modals/post-registration-welcome/post-registration-welcome.component';
import { CartSidebarComponent } from 'src/app/components/cart-sidebar/cart-sidebar.component';
import { ShippingPolicyComponent } from 'src/app/components/modals/shipping-policy/shipping-policy.component';
import { RouterModule } from '@angular/router';
import { CategorySliderComponent } from '../category-slider/category-slider.component';
import { MapComponent } from '../map/map.component';
import { ContentReviewsComponent } from '../content-reviews/content-reviews.component';
import { NotificationsComponent } from '../notifications/notifications.component';
import { BannerCarouselComponent } from '../banner-carousel/banner-carousel.component';
import { VerifyAccountComponent } from '../modals/verify-account/verify-account.component';
import { TemporaryInfoMessageComponent } from '../modals/temporary-info-message/temporary-info-message.component';
import { SearchBarComponent } from '../search-bar/search-bar.component';
import { FilterResultComponent } from '../modals/filter-result/filter-result.component';
import { ProductAddedToCartComponent } from '../modals/product-added-to-cart/product-added-to-cart.component';
import { AddAddressComponent } from '../modals/add-address/add-address.component';
import { CardProvidersComponent } from '../card-providers/card-providers.component';
import { RateProductComponent } from '../modals/rate-product/rate-product.component';
import { ThemeSelectorComponent } from '../theme-selector/theme-selector.component';
import { FloatingThemeSelectorComponent } from '../floating-theme-selector/floating-theme-selector.component';
import { CustomThemeModalComponent } from '../custom-theme-modal/custom-theme-modal.component';
import { ThemeService } from '../../services/theme/theme.service';
import { OptimizedI18nPipe } from '../../pipes/optimized-i18n.pipe';
// LanguageSelectorComponent y SimpleLanguageSelectorComponent eliminados

@NgModule({
  declarations: [
    LoaderComponent,
    CursorComponent,
    ScrollTopComponent,
    HeaderComponent,
    LoginComponent,
    NavMenuHeaderComponent,
    ProductSoldComponent,
    RecoverPasswordComponent,
    RecoverPassComponent,
    PostRegistrationWelcomeComponent,
    HeaderResponsiveComponent,
    PaginatorComponent,
    FooterComponent,
    RegisterComponent,
    ShippingPolicyComponent,
    HeaderPagesComponent,
    SlideBannersComponent,
    ReviewModalComponent,
    GuideModalComponent,
    CartSidebarComponent,
    MapComponent,
    ContentReviewsComponent,
    CategorySliderComponent,
    NotificationsComponent,
    BannerCarouselComponent,
    VerifyAccountComponent,
    TemporaryInfoMessageComponent,
    SearchBarComponent,
    FilterResultComponent,
    ProductAddedToCartComponent,
    AddAddressComponent,
    CardProvidersComponent,
    RateProductComponent,
    ThemeSelectorComponent,
    FloatingThemeSelectorComponent,
    CustomThemeModalComponent,
    OptimizedI18nPipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatMenuModule,
    FormsModule,
    RouterModule,
    InputsModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    MatExpansionModule,
    MatRadioModule,
    MatCardModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatIconModule
  ],
  exports: [
    RouterModule,
    LoaderComponent,
    CursorComponent,
    ScrollTopComponent,
    HeaderComponent,
    PaginatorComponent,
    HeaderResponsiveComponent,
    HeaderPagesComponent,
    SlideBannersComponent,
    FooterComponent,
    MatToolbarModule,
    RecoverPasswordComponent,
    VerifyAccountComponent,
    MatTableModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatMenuModule,
    MatButtonModule,
    PostRegistrationWelcomeComponent,
    NgxPaginationModule,
    ReviewModalComponent,
    GuideModalComponent,
    CategorySliderComponent,
    ContentReviewsComponent,
    MapComponent,
    LoginComponent,
    RegisterComponent,
    NavMenuHeaderComponent,
    BannerCarouselComponent,
    TemporaryInfoMessageComponent,
    SearchBarComponent,
    FilterResultComponent,
    ProductAddedToCartComponent,
    AddAddressComponent,
    CardProvidersComponent,
    RateProductComponent,
    ThemeSelectorComponent,
    FloatingThemeSelectorComponent,
    CustomThemeModalComponent,
    OptimizedI18nPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
